import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface CellContentModalData {
  title: string;
  content: string;
  isKeywords?: boolean;
  keywords?: string[];
}

@Component({
  selector: 'app-cell-content-modal',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <div class="cell-content-modal">
      <h3 mat-dialog-title class="!mb-1">{{ data.title }}</h3>
    
      <mat-dialog-content>
        <!-- Para texto normal (pregunta, contenido) -->
        @if (!data.isKeywords) {
          <p class="whitespace-pre-wrap text-light-text-secondary dark:text-dark-text-secondary">
            {{ data.content || '-' }}
          </p>
        }
    
        <!-- Para palabras clave -->
        @if (data.isKeywords) {
          <div class="flex flex-wrap gap-2">
            @for (keyword of data.keywords; track keyword) {
              <span
                class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary border border-light-primary/20 dark:border-dark-primary/30">
                {{ keyword }}
              </span>
            }
            @if (!data.keywords || data.keywords.length === 0) {
              <span
                class="text-light-text-tertiary dark:text-dark-text-tertiary">
                -
              </span>
            }
          </div>
        }
      </mat-dialog-content>
    
      <mat-dialog-actions align="end">
        <button
          (click)="close()"
        class="flex items-center font-medium h-10 !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">Cerrar</button>
      </mat-dialog-actions>
    </div>
    `,
  styles: [`
    .cell-content-modal {
      min-width: 300px;
      max-width: 65vw;
    }
    
    mat-dialog-content {
      max-height: 70vh;
      overflow-y: auto;
    }
    ::ng-deep {
    .mat-mdc-dialog-surface {
        border-radius: 24px !important;
        background: #ffffff !important; /* mismo fondo claro que usa el contenedor interno */
    }

    /* Forzar fondo oscuro cuando el sitio está en modo dark (tailwind usa la clase dark) */
    .dark .mat-mdc-dialog-surface {
        background: #1f1f1f !important;
    } 
}
  `]
})
export class CellContentModalComponent {
  constructor(
    public dialogRef: MatDialogRef<CellContentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CellContentModalData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
